/**
 * Decode percent-encoded cluster labels (Persian + spaces).
 * Falls back to the original string if decoding fails.
 */
export function decodeName(value: unknown): string {
  if (value == null) return '';
  const raw = String(value);
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw.replace(/\+/g, '%20'));
  } catch {
    decoded = raw;
  }
  return decoded === 'main' ? 'اصلی' : decoded;
}

export function decodeNameList(list: unknown[] = []): string[] {
  return list.map(decodeName);
}

/** True when the value already looks percent-encoded (as returned by API). */
export function isEncodedName(value: unknown): boolean {
  return /%[0-9A-Fa-f]{2}/.test(String(value ?? ''));
}

/**
 * Keep API-encoded names as-is; encode plain UI names with encodeURIComponent
 * so request paths match how the backend stores `name` fields.
 */
export function encodeName(value: unknown): string {
  const raw = String(value ?? '');
  if (!raw) return '';
  if (isEncodedName(raw)) return raw;
  return encodeURIComponent(raw);
}

export function encodeNamePath(path: string[] = []): string[] {
  return path.map(encodeName);
}
